import { render, staticRenderFns } from "./Box4.vue?vue&type=template&id=19bdb7c3&scoped=true"
import script from "./Box4.vue?vue&type=script&lang=js"
export * from "./Box4.vue?vue&type=script&lang=js"
import style0 from "./Box4.vue?vue&type=style&index=0&id=19bdb7c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bdb7c3",
  null
  
)

export default component.exports